import { triggerHelpInfoEvent } from '../actions/eventActions';
import { HpGetEventFunction, HpHelpInfoTypes } from '../actions/eventActionTypes';
import { createNavigationTabMenuEvents } from '../components/formControls/common/navigationTabMenuControl';

type HpEventListenerFunction = (event: MouseEvent, targetElement: HTMLElement) => void;

export function addTopLevelEventListener(): void {
  const handleMenuEvents = createMenuEventHandler();
  document.body.addEventListener('click', (event: MouseEvent) => {
    const targetElement = event.target as HTMLElement;
    if (targetElement && targetElement.tagName !== undefined) {
      handleHelpInfoEvents(event, targetElement);
      handleMenuEvents(event, targetElement);
    }
  });
}

function handleHelpInfoEvents(event: MouseEvent, targetElement: HTMLElement): void {
  const getEvent: HpGetEventFunction = () => event as any;
  const target = jQuery(targetElement);
  const summary = target.closest('summary');
  if (summary.length > 0) {
    const elementText = summary.text() || '';
    const { type, questionId } = getHelpOrInfoDetails();
    return triggerHelpInfoEvent({
      getEvent,
      type: type,
      elementType: 'accordian-link',
      elementText,
      questionId
    });
  } else {
    if (targetElement.tagName !== 'A') {
      return;
    }

    const href = (targetElement as HTMLAnchorElement).href || null;
    const { type, questionId } = getHelpOrInfoDetails();
    triggerHelpInfoEvent({
      getEvent,
      type,
      elementType: 'external-link',
      elementText: jQuery(targetElement).text() || undefined,
      questionId,
      href
    });
  }

  function getHelpOrInfoDetails(): HelpOrInfoDetails {
    let questionId = getElementQuestionId('.hp-info-container');
    if (!questionId) {
      questionId = getElementQuestionId('.hp-help-container');
      if (questionId) {
        return { type: 'help', questionId };
      } else {
        return { type: 'unknown', questionId: '' }; // Should not happen but can help to spot where it happens if it does.
      }
    }

    return { type: 'info', questionId };
  }

  function getElementQuestionId(selector: string): string | undefined {
    const helpOrInfo = target.closest(selector).get(0);
    if (helpOrInfo) {
      const questionPanelId = getParentId(helpOrInfo); // Easier to get it from the label.
      if (!questionPanelId) {
        return;
      }

      const questionId = questionPanelId.replace('QP', ''); // The destructure function doesn't work for question panels.
      return questionId;
    }
  }

  function getParentId(element: HTMLElement): string | undefined {
    return (element.parentElement as HTMLElement).id;
  }

  interface HelpOrInfoDetails {
    questionId: string;
    type: HpHelpInfoTypes;
  }
}

function createMenuEventHandler(): HpEventListenerFunction {
  const { menuClose } = createNavigationTabMenuEvents(null);
  return (event: MouseEvent, targetElement: HTMLElement) => {
    const selector = '.av-timeline-submenu';
    const menu = jQuery(selector);
    const closest: number = menu ? jQuery(targetElement).closest(selector).length : -1;
    if (closest === 0 && menu.is(':visible')) {
      const { openedAt } = menu.data() as HpMenuData;
      if (new Date().getTime() - openedAt > 100) {
        menuClose(event as any);
      }
    }
  };
}

export interface HpMenuData {
  openedAt: number;
}
